<app-advanced-search
  [uuid]="uuid"
  (emitGravesearchQuery)="onSearch($event)"
  (emitBackButtonClicked)="onBackClicked()" />
